import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HIGH_VOLUME_IMPORT_VEHICLE } from 'utils/constant';
import {
  filterOutOptionalExtrasFromFerryReservation,
  getReservationsByProductType,
  price,
} from 'utils/helpers';
import {
  fetchAttachments,
  fetchFamilies,
  fetchMakes,
} from 'redux/actions/vehicle_link';
import { getPrices } from 'redux/selectors/current_booking';
import { isLuggageEnabled } from 'redux/selectors/ferry_flow/luggage';
import { getLuggageSummaryFromBooking, getVehiclesInfo } from './helpers';

const useGetVehicles = (booking) => {
  const dispatch = useDispatch();
  const luggageEnabled = useSelector(isLuggageEnabled);
  const { vehiclePrice } = useSelector(getPrices);
  const {
    attachments = [],
    makes: vehicleMakes = [],
    families: vehicleFamilies = [],
  } = useSelector((state) => state.vehicleLink || {});
  const { vehicleTypes: qtVehicleTypes = [] } = useSelector(
    (state) => state.types || {}
  );
  const {
    vehicle_type_groups: cmsVehicleTypeGroups,
    vehicle_types: cmsVehicleTypes,
  } = useSelector((state) => state.sealink || {});

  const vehicles = booking.vehicles_attributes || [];
  let reservations = getReservationsByProductType('ferry,transfer', booking);
  reservations = filterOutOptionalExtrasFromFerryReservation({ reservations });

  let processedVehicles = [];

  useEffect(() => {
    if (vehicles.length) {
      dispatch(fetchAttachments());
      vehicles.forEach((vehicle) => {
        if (
          vehicle.make_code &&
          vehicle.make_code !== HIGH_VOLUME_IMPORT_VEHICLE
        ) {
          const segmentCode = qtVehicleTypes.find(
            (item) => item.id === vehicle.vehicle_type_id
          )?.segment_code;
          if (segmentCode) {
            dispatch(fetchMakes(segmentCode));
            dispatch(
              fetchFamilies({ code: segmentCode, makeCode: vehicle.make_code })
            );
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (vehicles.length) {
    if (luggageEnabled) {
      processedVehicles = [
        {
          icon: 'fas fa-suitcase',
          name: 'Additional Items',
          price: price(vehiclePrice),
          attachments: getLuggageSummaryFromBooking({
            vehicles,
            luggageTypes: qtVehicleTypes,
          }),
        },
      ];
    } else {
      processedVehicles = getVehiclesInfo({
        vehicleAttributes: vehicles,
        ferryReservations: reservations,
        vehicleMakes,
        vehicleFamilies,
        cmsVehicleTypes,
        cmsVehicleTypeGroups,
        qtVehicleTypes,
        attachments,
      });
    }
  }

  return processedVehicles;
};

export default useGetVehicles;
